(function () {
  'use strict';

  // Selettori specifici per Baseline
 const CONTEXTS = [
  {
    // Pagina collezione
    gridSelector: 'ul.collection-list',
    paginationSelector: 'ul.pagination',
    nextLinkSelector: 'ul.pagination a.theme-link:not(.theme-link--back)',
    itemSelector: 'ul.collection-list > li:not([class*="placeholder"]):not([class*="absolute"])',
  },
  {
    // Pagina ricerca
    gridSelector: '#results ul.grid',
    paginationSelector: 'ul.pagination',
    nextLinkSelector: 'ul.pagination a.theme-link:not(.theme-link--back)',
    itemSelector: '#results ul.grid > li:not([class*="placeholder"]):not([class*="absolute"])',
  },
];


  let loading = false;
  let observer = null;
  let activeContext = null;

  function detectContext() {
    for (const ctx of CONTEXTS) {
      if (document.querySelector(ctx.gridSelector) && document.querySelector(ctx.paginationSelector)) {
        return ctx;
      }
    }
    return null;
  }

  function init() {
    loading = false;
    if (observer) { observer.disconnect(); observer = null; }

    activeContext = detectContext();
    if (!activeContext) return;

    const nextLink = document.querySelector(activeContext.nextLinkSelector);
    if (!nextLink) return;

    // Nascondi il wrapper della paginazione
    const paginationWrapper = document.querySelector(activeContext.paginationSelector)?.closest('div');
    if (paginationWrapper) paginationWrapper.style.display = 'none';

    injectSpinner();
    observeScroll(nextLink.href);
  }

  function injectSpinner() {
    if (document.getElementById('infinite-scroll-spinner')) return;
    const spinner = document.createElement('div');
    spinner.id = 'infinite-scroll-spinner';
    spinner.style.cssText = 'text-align:center;padding:2rem;display:none;';
    spinner.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
        style="animation:is-spin 1s linear infinite;display:inline-block;">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"
          stroke-dasharray="31.4" stroke-dashoffset="10"/>
      </svg>
      <style>@keyframes is-spin{to{transform:rotate(360deg)}}</style>
    `;
    const grid = document.querySelector(activeContext.gridSelector);
    if (grid) grid.parentNode.appendChild(spinner);
  }

  function observeScroll(nextUrl) {
    const sentinel = document.createElement('div');
    sentinel.id = 'infinite-scroll-sentinel';
    sentinel.style.height = '1px';
    const grid = document.querySelector(activeContext.gridSelector);
    if (grid) grid.parentNode.appendChild(sentinel);

    observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loading) {
          loadMore(nextUrl);
        }
      },
      { rootMargin: '300px' }
    );
    observer.observe(sentinel);
  }

  async function loadMore(url) {
    loading = true;
    const spinner = document.getElementById('infinite-scroll-spinner');
    if (spinner) spinner.style.display = 'block';

    try {
      const response = await fetch(url);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      const newItems = doc.querySelectorAll(activeContext.itemSelector);
      const currentGrid = document.querySelector(activeContext.gridSelector);

      if (currentGrid && newItems.length) {
        // Rimuovi placeholder esistenti
        currentGrid.querySelectorAll('li[class*="placeholder"], li[class*="absolute"]')
          .forEach(el => el.remove());
        newItems.forEach(item => currentGrid.appendChild(item));
      }

      // Rimuovi sentinel vecchio
      document.getElementById('infinite-scroll-sentinel')?.remove();

      if (spinner) spinner.style.display = 'none';

      const newNextLink = doc.querySelector(activeContext.nextLinkSelector);
      if (newNextLink) {
        loading = false;
        observeScroll(newNextLink.href);
      } else {
        if (observer) observer.disconnect();
        spinner?.remove();
      }
    } catch (e) {
      console.error('Infinite scroll error:', e);
      const spinner = document.getElementById('infinite-scroll-spinner');
      if (spinner) spinner.style.display = 'none';
      loading = false;
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
